import "./Suppliers.module.css";
import Header from "@/reusable_sections/Header";
import HeroPartnerships from "./sections/HeroPartnerships";
import Partners from "./sections/Partners";
import SupplierBreakdown from "./sections/SupplierBreakdown";
import Footer from "@/reusable_sections/Footer";
export default function SuppliersPage() {
  return <div>
      <Header />
      <HeroPartnerships />
      <Partners />
      <SupplierBreakdown />
      <Footer />
    </div>;
}